import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import { useHitDecoder } from '../api';
import { Modal } from 'components/modal';
import styled from 'styled-components';
import spacing from 'theme/spacing';
import { PurPurButton } from 'components';
import { Select } from '@purpurds/purpur/select';
import { SlideInModal } from 'components/slide-in-modal';
const DropdownContainer = styled.div `
  margin-top: ${spacing.spacing16};
  width: 90%;
`;
const ButtonContainer = styled.div `
  display: flex;
  justify-content: center;
  margin-top: ${spacing.spacing16};
`;
const StyledButtonWrapper = styled.div `
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  margin-top: ${spacing.spacing16};
`;
export const HitDecoder = ({ customerId, isVisible, onClose, }) => {
    var _a;
    const provisioningCommands = useMemo(() => [
        { value: 'RESET_PIN', label: 'Nullstill PIN' },
        { value: 'REAUTH_SOFTWARE_ON_DEVICE', label: 'Oppdater programvare' },
        { value: 'REFRESH_DEVICE', label: 'Refresh device' },
        { value: 'RESEND_ALL_PACKETS', label: 'Resend All Packets' },
    ], []);
    const [selectedDevice, setSelectedDevice] = useState(null);
    const [selectedCommand, setSelectedCommand] = useState(null);
    const [successMessage, setSuccessMessage] = useState(null);
    const [errorMessage, setErrorMessage] = useState(null);
    const { dpads, isLoading, isFetching, sendCommand, isSending } = useHitDecoder(customerId);
    const deviceOptions = (_a = dpads === null || dpads === void 0 ? void 0 : dpads.map((device) => ({
        value: String(device.deviceId),
        label: device.modelName,
    }))) !== null && _a !== void 0 ? _a : [];
    const handleFirstDropdownChange = (e) => {
        const selectedValue = e.target.value;
        if (!selectedValue) {
            setSelectedDevice(null);
            return;
        }
        const mapDeviceToOption = (device) => ({
            value: device.deviceId,
            label: device.modelName,
        });
        const device = dpads === null || dpads === void 0 ? void 0 : dpads.find((d) => String(d.deviceId) === selectedValue);
        setSelectedDevice(device ? mapDeviceToOption(device) : null);
    };
    const handleSecondDropdownChange = (e) => {
        const selectedValue = e.target.value;
        const command = provisioningCommands.find((cmd) => cmd.value === selectedValue);
        setSelectedCommand(command !== null && command !== void 0 ? command : null);
    };
    const handleButtonClick = async () => {
        const result = await sendCommand(selectedDevice, selectedCommand);
        if (!result)
            return;
        if (result.success) {
            setSuccessMessage(result.message);
        }
        else {
            setErrorMessage(result.message);
        }
    };
    return (_jsxs(SlideInModal, { display: isVisible, onClose: onClose, mainHeading: "Reprovisjoner boks", children: [_jsx(DropdownContainer, { children: _jsx(Select, { label: "Boks", onChange: handleFirstDropdownChange, options: deviceOptions, value: selectedDevice ? String(selectedDevice.value) : '', placeholder: {
                        label: 'Select Boks',
                        value: ''
                    }, loading: isLoading || isFetching }) }), _jsx(DropdownContainer, { children: _jsx(Select, { label: "Kommando", onChange: handleSecondDropdownChange, options: provisioningCommands, value: (selectedCommand === null || selectedCommand === void 0 ? void 0 : selectedCommand.value) || '', placeholder: {
                        label: 'Select kommando',
                        value: ''
                    } }) }), _jsx(ButtonContainer, { children: _jsx(PurPurButton, { variant: "primary", disabled: !selectedDevice || !selectedCommand, onClick: handleButtonClick, loading: isSending, children: isSending ? 'Sender...' : 'Gjennomfør' }) }), successMessage && (_jsx(Modal, { title: "Success", isOpen: !!successMessage, onClose: () => setSuccessMessage(null), style: 'success', actionButtons: _jsx(StyledButtonWrapper, { children: _jsx(PurPurButton, { size: "sm", type: "button", variant: "secondary", onClick: () => setSuccessMessage(null), children: "OK" }) }), children: successMessage })), errorMessage && (_jsx(Modal, { title: "Error", isOpen: !!errorMessage, onClose: () => setErrorMessage(null), style: 'error', actionButtons: _jsx(StyledButtonWrapper, { children: _jsx(PurPurButton, { size: "sm", type: "button", variant: "secondary", onClick: () => setErrorMessage(null), children: "OK" }) }), children: errorMessage }))] }));
};
